class FooterStickWrapper extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("resize", () => this._setOffset());
  }

  connectedCallback() {
    this._setOffset();
  }

  disconnectedCallback() {}

  _setOffset() {
    const { height } = this.querySelector(".footer").getBoundingClientRect();

    this.style.setProperty(
      "--stick-offset",
      `-${window.innerHeight - height}px`,
    );
  }
}

if (!customElements.get("footer-stick-wrapper")) {
  customElements.define("footer-stick-wrapper", FooterStickWrapper);
}
